import { Button, Checkbox, Col, Form, Input, Modal, Row, Upload } from "antd";
import React from "react";

export default function NewEducationalContentModal({
  selectedTreatmentForEducationalContent,
  handleCheckboxChange,
  handleUploadChange2,
  postEducational,
  isModalVisible2,
  handleCancel2,
  isChecked,
  videoFile,
  setText,
  setName,
  setUrl,
  form,
  url,
  add,
}) {
  return (
    <Modal open={isModalVisible2} style={{ minWidth: 300, minHeight: 800 }} footer={null} onCancel={handleCancel2}>
      <Form layout="vertical" form={form}>
        <p style={{ fontSize: 16, fontWeight: 600, marginTop: 30 }}>
          Add Educational Content for {selectedTreatmentForEducationalContent && selectedTreatmentForEducationalContent.treatment}
        </p>

        <Form.Item label="Content Name" name="contentName" rules={[{ required: true, message: "Please enter the content name!" }]}>
          <Input
            style={{ height: 39, borderRadius: 8, border: "1px solid #6B43B5" }}
            placeholder="Enter Name for Content"
            onChange={(e) => setName(e.target.value)}
          />
        </Form.Item>

        <Form.Item
          label="Content Description"
          name="contentDescription"
          rules={[
            {
              required: true,
              message: "Please enter the content description!",
            },
          ]}
        >
          <Input
            style={{ height: 74, borderRadius: 8 }}
            placeholder="Write Content Description..."
            rows={4}
            onChange={(e) => setText(e.target.value)}
          />
        </Form.Item>

        <Form.Item
          label={
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
              Content
              <div style={{ display: "flex", alignItems: "center", marginLeft: "auto" }}>
                <span style={{ marginRight: 10, marginLeft: 330 }}>Redirect</span>
                <Checkbox onChange={handleCheckboxChange} checked={isChecked} />
              </div>
            </div>
          }
          name="contentUrl"
          rules={[{ required: false, message: "Please enter the content URL!" }]}
        >
          <Input
            style={{ height: 39, borderRadius: 8, border: "1px solid #6B43B5" }}
            placeholder="Enter Content URL"
            onChange={(e) => setUrl(e.target.value)}
            disabled={videoFile.length > 0}
          />
        </Form.Item>

        <Form.Item>
          <Col
            style={{
              padding: 0,
              border: "1px dashed #B7B7B7",
              borderWidth: 3,
              borderRadius: 8,
              display: "inline-block",
              verticalAlign: "top",
              marginLeft: 15,
              width: "95%",
            }}
          >
            <div className="clearfix" style={{ width: "100%" }}>
              <Upload beforeUpload={() => false} showUploadList={false} onChange={handleUploadChange2} disabled={!!url}>
                <label
                  className="formLabel"
                  style={{
                    color: "gray",
                    backgroundColor: "none",
                    display: "flex",
                    height: "81px",
                    alignItems: "center",
                    justifyContent: "center",
                    borderRadius: "8px",
                    cursor: "pointer",
                    maxWidth: "250px",
                    minWidth: "unset",
                    padding: "15px",
                    flexDirection: "column",
                    fontSize: 14,
                    marginLeft: "40%",
                  }}
                >
                  <div style={{ top: -15, position: "relative" }}>
                    <img src={add} alt="" />
                  </div>

                  <div
                    style={{
                      color: "#B7B7B7",
                      fontSize: 12,
                      marginBottom: 5,
                      width: "100%",
                    }}
                  >
                    Drag and drop or <span style={{ color: "#6B43B5" }}>Browse</span> your files
                  </div>
                </label>
              </Upload>
            </div>
          </Col>
        </Form.Item>
        <Row justify="end" style={{ marginTop: 35 }}>
          <Form.Item>
            <Button type="primary" htmlType="submit" onClick={() => postEducational()} style={{ width: 139, height: 38, fontSize: 16 }}>
              Add
            </Button>
          </Form.Item>
        </Row>
      </Form>
    </Modal>
  );
}
